import { Link } from "react-router-dom";
import useMember from "@/hooks/useMember";

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export default function MemberGate({ children, fallback }: Props) {
  const { member, loading } = useMember();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-32">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-primary/20 border-t-primary rounded-full animate-spin mx-auto mb-4" />
          <p className="font-body text-sm text-brown/60">Verificando acesso...</p>
        </div>
      </div>
    );
  }

  if (member) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return (
    <div className="w-full px-6 md:px-10 lg:px-16 max-w-lg mx-auto text-center">
      <div className="bg-white rounded-2xl p-10 md:p-14">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-50 mx-auto mb-6">
          <i className="ri-shield-user-line text-2xl text-amber-500" />
        </div>
        <h3 className="font-display text-xl text-brown mb-3">
          Área exclusiva para membros
        </h3>
        <p className="font-body text-brown/70 text-base leading-relaxed mb-3">
          Esse recurso está disponível apenas para integrantes aprovadas da comunidade Entre Elas.
        </p>
        <p className="font-body text-brown/50 text-sm leading-relaxed mb-8">
          Se você já se cadastrou e foi aprovada, verifique o email com o link para completar seu perfil.
          Após finalizar o cadastro, você terá acesso completo.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/cadastro"
            className="inline-block font-body text-sm px-8 py-3 rounded-full bg-primary text-white tracking-wide uppercase transition-all duration-300 hover:bg-primary-dark whitespace-nowrap"
          >
            Quero me cadastrar
          </Link>
          <Link
            to="/"
            className="inline-block font-body text-sm px-8 py-3 rounded-full border border-nude text-brown tracking-wide uppercase transition-all duration-300 hover:bg-beige whitespace-nowrap"
          >
            Voltar para o início
          </Link>
        </div>
      </div>
    </div>
  );
}